// TODO: remove after Phase 2
function exportToWindowWithWarning(obj, name, isMDigital = false) {
  window[name] = {};    

  const msg = () => console.warn(`${name} will be deprecated! Please, use in future KAMPYLE_ONSITE_SDK instead!`);
  if(typeof obj === 'object') {
    if(isMDigital) { // For nesting - MDIGITAL
      window.MDIGITAL[name] = {};
    }
    Object.entries(obj).map(([key, method]) => {
        if(typeof method === 'function') {
            const initial = method;
              if(isMDigital){
                window.MDIGITAL[name][key] = function() {
                  msg();
                  return initial.apply(window, arguments);           
              }
            } else {
              window[name][key] = function() {
                  msg();
                  return initial.apply(window, arguments); 
              }
          }
        } else {
          Object.defineProperty(window[name], key, {
            get() {
              msg();
              return method;
            }
          });
        }
    });
  }
}

export default exportToWindowWithWarning; 